
import { useState } from "react";
import { Policy, Acknowledgment } from "@/types";

export const usePolicyStorage = (initialPolicies: Policy[]) => {
  const [policies, setPolicies] = useState<Policy[]>(initialPolicies);
  const [acknowledgments, setAcknowledgments] = useState<Acknowledgment[]>([]);
  
  const loadFromStorage = () => {
    const storedAcknowledgments = localStorage.getItem("acknowledgments");
    if (storedAcknowledgments) {
      setAcknowledgments(JSON.parse(storedAcknowledgments));
    }
    
    const storedPolicies = localStorage.getItem("policies");
    if (storedPolicies) {
      setPolicies(JSON.parse(storedPolicies));
    }
  };
  
  const saveToStorage = (updatedPolicies: Policy[], updatedAcknowledgments?: Acknowledgment[]) => {
    localStorage.setItem("policies", JSON.stringify(updatedPolicies));
    
    if (updatedAcknowledgments) {
      localStorage.setItem("acknowledgments", JSON.stringify(updatedAcknowledgments));
    }
  };
  
  return {
    policies,
    setPolicies,
    acknowledgments,
    setAcknowledgments,
    loadFromStorage,
    saveToStorage
  };
};
